import { render, staticRenderFns } from "./juryAdd.vue?vue&type=template&id=9ffc9738"
import script from "./juryAdd.vue?vue&type=script&lang=js"
export * from "./juryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ffc9738')) {
      api.createRecord('9ffc9738', component.options)
    } else {
      api.reload('9ffc9738', component.options)
    }
    module.hot.accept("./juryAdd.vue?vue&type=template&id=9ffc9738", function () {
      api.rerender('9ffc9738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/jury/juryAdd.vue"
export default component.exports